import React, { Component } from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { Link } from 'react-scroll';
import { withStyles } from '@material-ui/core/styles';
import './Menu.css';


const styles = {
    root: {
        padding: '10px 23px!important',
        height: '42px',
    },
    rootListFullWidth: {
        padding: '0px!important',
        textAlign: 'center',
        // height: '42px',
        // height: '54px',
    },
    button: {
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.1)'
        }
    },
    topNavStyle: {
        textAlign: 'center',
        width: '65px',
        zIndex: 10,
        backgroundColor: 'rgba(0, 0, 0, 0.25)',// '#252324' /*'#E0F2F1'*/,
        position: 'absolute',
        top: '42px',
        left: '0px',
        // transform: 'translate(0,-50%)',
        padding: '0px 0px',
        paddingBottom: '0px'
    },
    // avatarContainer: {
    //     display: 'inline-block',
    //     position: 'relative',
    //     marginTop: '-40px',
    //     height: '60px',
    // },
    avatar: {
        width: 60,
        height: 60,
        position: 'relative',
    },
    iconContainer: {
        // position: 'absolute',
        // bottom: '0px',
        // right: '0px',
        // cursor: 'pointer'
    },
    listItemName: {
        fontSize: '18px',
        color: '#fff',
        display: 'inline-block',
        verticalAlign: 'middle',
        marginLeft: '11px'
    }
};

class Menu extends Component {
    render() {
        const { classes } = this.props;
        return (
            <div className={classes.topNavStyle}>
                <List defaultValue={1}>
                    {this.props.navigation.map((element, i) => {
                        let listItem = (
                            <ListItem key={i} button value={i} className='pdc-menu-item'
                                classes={{
                                    root: element.reactComponent !== undefined ? classes.root : classes.rootListFullWidth,
                                    button: classes.button
                                }}
                                onClick={element.reactComponent === undefined || this.props.containerElementId !== undefined ? undefined : () => this.props.handleSetActive(i)}
                            >
                                {element.iconElement}
                            </ListItem>
                        );
                        if (element.reactComponent !== undefined && this.props.containerElementId !== undefined) {
                            return (
                                <Link
                                    data-id={element.id}
                                    key={i}
                                    activeClass='active'
                                    to={element.id}
                                    spy={true}
                                    smooth={true}
                                    duration={250}
                                    containerId={this.props.containerElementId}
                                    onSetActive={this.props.handleSetActive}
                                >
                                    {listItem}
                                </Link>
                            );
                        } else {
                            return listItem;
                        }
                    })}
                </List>
            </div>
        );
    }
}
Menu.propTypes = {
    navigation: PropTypes.array.isRequired,
    containerElementId: PropTypes.string,
    handleSetActive: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Menu);
